/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useState } from 'react'

import { EuiButton, EuiContextMenuPanel, EuiPopover } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import genericMessages from '@modules/project-lib/genericMessages'
import type { AnyAdminProject } from '@modules/project-admin-api/types'
import { isProjectDeleted } from '@modules/project-admin-lib/deleted'

import DeleteProjectButton from './DeleteProjectButton'
import ReprocessProjectButton from './ReprocessProjectButton'
import RestoreProjectButton from './RestoreProjectButton'

export type Props = {
  project: AnyAdminProject
}

const AdminProjectActionsButton: React.FunctionComponent<Props> = ({ project }) => {
  const [isOpen, setIsOpen] = useState(false)

  const items = [
    <ReprocessProjectButton
      key='reprocess'
      project={project}
      onComplete={() => setIsOpen(false)}
    />,
    <DeleteProjectButton key='delete' project={project} onComplete={() => setIsOpen(false)} />,
  ]

  if (isProjectDeleted(project)) {
    items.push(
      <RestoreProjectButton key='restore' project={project} onComplete={() => setIsOpen(false)} />,
    )
  }

  return (
    <EuiPopover
      button={
        <EuiButton
          fill={false}
          iconType='arrowDown'
          iconSide='right'
          onClick={() => setIsOpen(!isOpen)}
        >
          <FormattedMessage {...genericMessages.actions} />
        </EuiButton>
      }
      isOpen={isOpen}
      closePopover={() => setIsOpen(false)}
      panelPaddingSize='none'
    >
      <EuiContextMenuPanel items={items} />
    </EuiPopover>
  )
}

export default AdminProjectActionsButton
